export default {
  hubTitle: 'تنظیمات صندوق و حسابداری',
  hubBadge: 'Treasury & Ledger Hub',
  hubDescription: 'مدیریت و پیکربندی صندوق‌های نقدی شعبات، نگاشت حساب‌های کویک‌بوکس و استعلام موجودی زنده.',
  tabs: {
    cashBooks: 'دفاتر صندوق CRM',
    cashBoxes: 'دفاتر صندوق CRM',
    qboAccounts: 'حساب‌های کویک‌بوکس',
    payees: 'طرف‌های پرداخت (Payees)',
  },
  cashBooks: {
    title: 'دفاتر صندوق شعبات',
    badge: 'مدیریت خزانه‌داری و دفاتر صندوق',
    description: 'مدیریت دفاتر صندوق شعبات و اتصال مستقیم آن‌ها به حساب‌های دارایی متناظر در کویک‌بوکس.',
    totalBoxes: 'کل دفاتر صندوق',
    linkedCount: 'متصل به کویک‌بوکس',
    unlinkedCount: 'بدون پیوند',
    openBoxes: 'شیفت‌های فعال امروز',
    columns: {
      seq: '#',
      branch: 'شعبه و کد',
      city: 'شهر / موقعیت',
      drawerBalance: 'موجودی دفتر صندوق (CRM)',
      dayStatus: 'وضعیت روز',
      mappedQbo: 'حساب متناظر در کویک‌بوکس',
      qboBalance: 'موجودی در کویک‌بوکس',
      variance: 'مغایرت / تفاوت',
      active: 'فعال در CRM',
      actions: 'عملیات',
      editBook: 'ویرایش دفتر صندوق و شعبه',
      linkQbo: 'پیوند به حساب QBO',
      unlinked: '— بدون پیوند',
      balanced: 'تراز (بدون مغایرت)',
      open: 'باز',
      closed: 'بسته',
    },
    dialog: {
      mapTitle: 'پیوند دفتر صندوق شعبه به کویک‌بوکس: {name}',
      mapDesc: 'حساب بانکی/نقدی متناظر در کویک‌بوکس را برای ثبت و واریز خودکار دریافتی‌های این شعبه انتخاب نمایید.',
      selectAccount: 'انتخاب حساب بانکی/نقدی کویک‌بوکس',
      selectAccountPlaceholder: 'یک حساب از دارایی‌های نقدی انتخاب کنید...',
      searchAccount: 'جستجوی نام یا کد حساب...',
      unlink: 'حذف پیوند با این حساب',
      save: 'ذخیره نگاشت',
      saving: 'در حال ذخیره...',
      success: 'پیوند دفتر صندوق با حساب کویک‌بوکس با موفقیت به‌روزرسانی شد.',
      noAccount: 'حساب متناظری یافت نشد.',
      activeLabel: 'فعال در CRM',
      activeHint: 'آیا کاربران و تحویل‌داران مجاز به ثبت دریافت و پرداخت در این دفتر صندوق هستند؟',
      cancel: 'انصراف',
    },
    editDialog: {
      title: 'ویرایش دفتر صندوق: {name}',
      desc: 'تغییر شعبه متناظر، نام دفتر صندوق، کد، شهر و حساب متصل در کویک‌بوکس.',
      branchLabel: 'شعبه متصل',
      branchPlaceholder: 'انتخاب شعبه...',
      nameLabel: 'نام دفتر صندوق',
      codeLabel: 'کد دفتر صندوق',
      cityLabel: 'شهر / موقعیت',
      qboAccountLabel: 'حساب نقدی در کویک‌بوکس',
      activeLabel: 'فعال در CRM',
      activeHint: 'آیا تحویل‌داران مجاز به ثبت تراکنش در این دفتر صندوق هستند؟',
      save: 'ذخیره تغییرات',
      saving: 'در حال ذخیره...',
      cancel: 'انصراف',
      success: 'مشخصات دفتر صندوق با موفقیت ذخیره شد.',
      branchRequired: 'لطفاً یک شعبه را انتخاب نمایید.',
    },
  },
  cashBoxes: {
    title: 'صندوق‌های نقدی شعبات',
    badge: 'مدیریت خزانه‌داری و صندوق',
    description: 'مدیریت صندوق‌های نقدی فیزیکی شعبات و اتصال مستقیم آن‌ها به حساب‌های دارایی متناظر در کویک‌بوکس.',
    totalBoxes: 'کل صندوق‌ها',
    linkedCount: 'متصل به کویک‌بوکس',
    unlinkedCount: 'بدون پیوند',
    openBoxes: 'شیفت‌های فعال امروز',
    columns: {
      seq: '#',
      branch: 'شعبه و کد',
      city: 'شهر / موقعیت',
      drawerBalance: 'موجودی دخل (CRM)',
      dayStatus: 'وضعیت روز',
      mappedQbo: 'حساب متناظر در کویک‌بوکس',
      qboBalance: 'موجودی در کویک‌بوکس',
      variance: 'مغایرت / تفاوت',
      active: 'فعال در CRM',
      actions: 'عملیات',
      linkQbo: 'پیوند به حساب QBO',
      unlinked: '— بدون پیوند',
      balanced: 'تراز (بدون مغایرت)',
      open: 'باز',
      closed: 'بسته',
    },
    dialog: {
      mapTitle: 'پیوند صندوق شعبه به کویک‌بوکس: {name}',
      mapDesc: 'حساب بانکی/نقدی متناظر در کویک‌بوکس را برای ثبت و واریز خودکار دریافتی‌های این شعبه انتخاب نمایید.',
      selectAccount: 'انتخاب حساب بانکی/نقدی کویک‌بوکس',
      selectAccountPlaceholder: 'یک حساب از دارایی‌های نقدی انتخاب کنید...',
      searchAccount: 'جستجوی نام یا کد حساب...',
      unlink: 'حذف پیوند با این حساب',
      save: 'ذخیره نگاشت',
      saving: 'در حال ذخیره...',
      success: 'پیوند صندوق با حساب کویک‌بوکس با موفقیت به‌روزرسانی شد.',
      noAccount: 'حساب متناظری یافت نشد.',
      activeLabel: 'فعال در CRM',
      activeHint: 'آیا کاربران و تحویل‌داران مجاز به ثبت دریافت و پرداخت در این دخل هستند؟',
      cancel: 'انصراف',
    },
  },
  title: 'حساب‌های مالی QuickBooks',
  badge: 'Chart of Accounts · CRM Hub',
  description: 'مدیریت و نگاشت نام‌های فارسی/دری و پایش موجودی لحظه‌ای ۱۲۴ حساب کویک‌بوکس.',
  sync: 'همگام‌سازی از QuickBooks',
  syncing: 'در حال همگام‌سازی...',
  syncSuccess: 'همگام‌سازی تکمیل شد',
  syncSuccessDesc: '{count} حساب از QuickBooks با موفقیت بررسی و به‌روزرسانی شدند.',
  syncError: 'خطا در همگام‌سازی با QuickBooks',
  addManual: 'افزودن حساب دستی',
  totalAccounts: 'کل حساب‌ها',
  mapped: 'نام‌گذاری شده',
  unmapped: 'بدون نام فارسی',
  liveConnected: 'اتصال زنده QBO فعال',
  classes: {
    all: 'همه حساب‌ها',
    asset: 'دارایی‌ها (Asset)',
    liability: 'بدهی‌ها (Liability)',
    equity: 'سرمایه (Equity)',
    expense: 'مصارف (Expense)',
    revenue: 'عواید (Revenue)',
    accountsCount: '{count} حساب',
  },
  filters: {
    searchPlaceholder: 'جستجو در نام، کد QBO، کلید...',
    mappedStatus: 'وضعیت نام فارسی',
    allMapped: 'همه (وضعیت نام فارسی)',
    onlyMapped: 'دارای نام فارسی (نگاشت‌شده)',
    onlyUnmapped: 'بدون نام فارسی (نیاز به نگاشت)',
    balanceStatus: 'وضعیت موجودی',
    allBalances: 'همه حساب‌ها (موجودی)',
    hasBalance: 'دارای موجودی (غیرصفر)',
    zeroBalance: 'موجودی صفر',
    crmStatus: 'وضعیت در CRM',
    allCrm: 'همه وضعیت‌ها در CRM',
    activeCrm: 'فقط فعال در CRM',
    inactiveCrm: 'غیرفعال در CRM',
    clearFilters: 'پاک‌سازی فیلترها',
  },
  columns: {
    seq: '#',
    qboId: 'کد QBO',
    name: 'نام در کویک‌بوکس (English)',
    nameFa: 'نام فارسی در CRM',
    classification: 'طبقه‌بندی',
    accountType: 'نوع حساب',
    currentBalance: 'موجودی زنده',
    categoryKey: 'کلید سیستم',
    isActiveInCrm: 'فعال در CRM',
    copySuccess: 'کد حساب کپی شد',
    addPersianName: 'ثبت نام فارسی',
    editAccount: 'ویرایش نگاشت حساب',
    refreshBalance: 'استعلام موجودی زنده',
    balanceUpdated: 'موجودی به‌روزرسانی شد',
  },
  dialog: {
    editTitle: 'ویرایش نگاشت حساب: {name}',
    qboCode: 'کد QBO',
    classification: 'طبقه‌بندی',
    nameFaLabel: 'نام فارسی / دری حساب (نمایش در CRM)',
    nameFaPlaceholder: 'مثال: معاشات و دستمزد کارمندان، کرایه دفتر، تیل جنراتور...',
    nameFaHint: 'این نام در فرم‌های دریافت/پرداخت، راپور مصارف و دفتر صندوق به کاربر نمایش داده می‌شود.',
    categoryKeyLabel: 'کلید دسته‌بندی سیستم (System Category Key)',
    categoryKeyPlaceholder: 'مثال: wages_salaries, office_rent, fuel...',
    activeInCrmLabel: 'فعال در سیستم CRM',
    activeInCrmHint: 'آیا این حساب در لیست‌های کشوی دریافت/پرداخت قابل انتخاب باشد؟',
    allowedInVoucher: 'مجاز در سند پرداخت',
    allowedInVoucherDesc: 'قابل انتخاب در Payment Voucher',
    allowedInExpense: 'مجاز در راپور مصارف',
    allowedInExpenseDesc: 'قابل انتخاب در Expense Report',
    descriptionLabel: 'یادداشت و توضیحات داخلی',
    descriptionPlaceholder: 'توضیحات اختیاری...',
    cancel: 'انصراف',
    save: 'ذخیره تغییرات',
    saving: 'در حال ذخیره...',
    createTitle: 'افزودن حساب جدید در CRM',
    createDesc: 'مشخصات حساب متناظر با کویک‌بوکس را برای استفاده در CRM وارد نمایید.',
    nameEnLabel: 'نام حساب در کویک‌بوکس (English)',
    nameEnPlaceholder: 'مثال: Generator Repair Expense',
    currencyLabel: 'واحد پولی',
    afn: 'افغانی (AFN)',
    usd: 'دالر (USD)',
    create: 'ثبت حساب',
    creating: 'در حال ثبت...',
    statusUpdated: 'تغییر وضعیت انجام شد',
    statusUpdatedDesc: 'حساب {name} در فرم‌های CRM {status} شد.',
  },
};
